export default {
  types: [],
  typeGroups: {},
  typeParams: {},
  // Forms
  contactTypes: false,
  attributes: false
}



// WEBPACK FOOTER //
// ./src/apps/crm/contacts/store/common/state.js